const NETWORK_ERRORS = [
  '502 Bad Gateway',
  'Error: 404',
  'Load failed',
  'Failed to fetch',
  'network error',
  'Fetch failed, please try again.',
  'Max queue length has been reached',
  'NetworkError when attempting to fetch resource.',
  'The session has expired.',
  'avbruten',
]

const GOOGLE_MAPS_ERRORS = [
  'Not initialized.',
  "undefined is not an object (evaluating 'a.getDiv().hasAttribute')",
  // Match possible combinations of eg. "null is not an object (evaluating 'a4[c].indexOf')"
  new RegExp(
    "null is not an object \\(evaluating '[A-Za-z]4\\[c\\]\\.indexOf'\\)",
  ),
  'The Google Maps JavaScript API could not load.',
  // Match ~#!#~70~#!#~LabelerCrash type of errors
  new RegExp(
    '~#!#~\\d+~#!#~(?:LabelerCrash|EpochMismatch|Hung Labeler|wasm|out of memory).*~#!#~',
  ),
  new RegExp('Could not load "(?:controls|map|webgl|onion|stats)"\\.'),
  "Can't find variable: gmo",
  // Match possible combinations of eg. "this.ab.close is not a function. (In 'this.ab.close()', 'this.ab.close' is undefined)"
  new RegExp(
    "this\\.[a-zA-Z]{2}\\.close is not a function(?:\\. \\(In 'this\\.[a-zA-Z]{2}\\.close\\(\\)', 'this\\.[a-zA-Z]{2}\\.close' is undefined\\))?",
  ),
]

const IMPORT_ERRORS = [
  'Unable to preload CSS',
  'error loading dynamically imported module',
]

const EDGE_ERRORS = ["Can't find variable: logMutedMessage"]

const EXTENSION_ERRORS = ['zp_token is not defined']

export const SENTRY_IGNORE_ERRORS = [
  'ResizeObserver loop limit exceeded',
  ...NETWORK_ERRORS,
  ...GOOGLE_MAPS_ERRORS,
  ...IMPORT_ERRORS,
  ...EDGE_ERRORS,
  ...EXTENSION_ERRORS,
]
